export enum Status {
    DRAFT = 'draft',
    ON_AGREEMENT = 'onAgreement',
    IN_EXPLOITATIONS = 'inExploitations',
    COMPLETED = 'completed',
}

export interface IEstimateInformationContext {
    isOpenCreateEstimateModal: boolean;
    onOpenCreateEstimateModal: () => void;
    onCloseCreateEstimateModal: () => void;
    isOpenGanttModal: boolean;
    onOpenGanttModal: () => void;
    onCloseGanttModal: () => void;
    isActiveSingleListSorting: boolean;
    onActiveSingleListSorting: () => void;
    onHandleAddEmployeesModal: (value: 'managers' | 'purchasers' | null) => void;
    isOpenAddEmployeesModal: 'managers' | 'purchasers' | null;
    status: Status;
    onSetStatus: (status: Status) => void;
}

export interface IProject {
    id: number;
    name: string;
    url: string;
}

export interface IEmployee {
    id: number;
    name?: string;
    email: string;
    avatarUrl: string;
    isPending: boolean;
}

export interface IEstimate {
    name: string;
    url: string;
    cost: string;
    currencySign: string;
}

export interface IStatus {
    code: Status;
    availableStatuses: Status[];
    canSwitchStatus: boolean;
    workAndCustomerApprovalLockedByTariff: boolean;
}

export interface IPurchasersData {
    purchasers: IEmployee[];
    canAdd: boolean;
}

export interface IManagersData {
    managers: IEmployee[];
    canAdd: boolean;
}

export interface IEstimateInformation {
    title: string;
    project: IProject;
    address: string;
    status: IStatus;
    purchasersData: IPurchasersData;
    managersData: IManagersData;
    employees: IEmployee[];
    childEstimates: IEstimate[];
    parentEstimate: IEstimate | null;
    purchasePageInSortMode: boolean;
    canAddChildEstimate: boolean;
    canViewSchedule: boolean;
    canExportPurchaseAct: boolean;
}
